import { takeLatest } from "redux-saga/effects";
import getUserConfigWorker from "./getUserConfigWorker";
import getVendorConfigWorker from "./getVendorConfigWorker";

export function* configWatcher() {
    yield takeLatest("config/getUserConfigFetch", getUserConfigWorker);
    yield takeLatest("config/getVendorConfigFetch", getVendorConfigWorker);
}